import {Component, Input, Output, EventEmitter} from '@angular/core';
import { RowArgs} from '@progress/kendo-angular-grid';
import {spro_cli_columnGrid} from '../../interfaces/spro-columnGrid';
import {spro_enum_columnType} from "../../enums/spro-columnType.enum";
import {spro_cls_varGlobal} from "../../spro-varGlobal";
import {IntlService} from "@progress/kendo-angular-intl";

/*##################################################################################*
 * COMPOSANT SPRO : spro-grid-detail
 *
 * DESCRIPTION : Composant pour l'affichage d'une grid Kendo dans une autre grid
 ##################################################################################*/

@Component({
  selector: 'spro-grid-detail',
  styleUrls: ['./spro-grid.component.scss'],
  templateUrl: './spro-grid-detail.component.html'
})
export class spro_cls_grid_detail {

  /** Nom de la page afin de gérer la traduction */
  @Input() w_titre_trad: string;
  /** Données visualisées dans la grid */
  @Input() public h_gridView: any;
  /** Détail via la spro-grid-detail*/
  @Input() h_detailGrid_columns: spro_cli_columnGrid[] = null;
  /** Largeur de la colonne contenant la case à cocher de sélection */
  @Input() i_detailGridSelLargCol: number = 10;

  /** Evénements sur sélection de ligne */
  @Output() e_selectRow: EventEmitter<any> = new EventEmitter();

  /** Stockage de la ligne sélectionnée */
  public h_selectedLine: any[] = [];

  /** Réinitialise l'enum pour qu'il soit accessible côté html */
  public spro_enum_columnType = spro_enum_columnType;

  /**
   * Constructeur
   */
  constructor(public s_intl: IntlService,
    public s_proGlobal: spro_cls_varGlobal) {}

  /**
   *  Clé de valeur d'une Sélection
   */
  public proc_selectionKeys(context: RowArgs): number {
    return context.dataItem;
  }

  /**
   * Sur sélection de ligne
   */
  public proc_selectHandler({selectedRows}) {
    this.e_selectRow.emit(this.h_selectedLine);
  }

  /**
   * Formate une date pour l'afficher
   */
  public proc_formatDate(val: Date): string {
    if (val == null)
      return "";

    return this.s_intl.formatDate(val, this.s_proGlobal.w_formatDate);
  }

  /**
   * Formate un nombre pour l'afficher
   */
  public proc_formatNumber(w_typed: string, val: any): string {
    if (val == null)
      return "";

    let w_retour: string = val;
    if (w_typed === "monetaire")
      w_retour = w_retour + " €";
    else if (w_typed === "pourcentage")
      w_retour = w_retour + " %";

    return w_retour;
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/grids/spro-grid/spro-grid-detail.component.ts